/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceStepResponseEmailThreadMode = typeof SequenceStepResponseEmailThreadMode[keyof typeof SequenceStepResponseEmailThreadMode] | null;


export const SequenceStepResponseEmailThreadMode = {
  new_thread: 'new_thread',
  reply: 'reply',
} as const;
